import { render, staticRenderFns } from "./UserRatings.vue?vue&type=template&id=f744b700&"
import script from "./UserRatings.vue?vue&type=script&lang=js&"
export * from "./UserRatings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports